// 凡科统一跳转
export function handleFkOutLink(url, context) {
	// 检查必要参数
	if (!url) {
		return console.error('handleFkOutLink url 不能为空')
	}
	if (!context || !context.$store || !context.$router) {
		return console.error('handleFkOutLink context 参数不完整，需要包含 $store 和 $router')
	}

	// 处理凡科链接
	const fxUrl = encodeURIComponent(url)

	// 获取环境配置
	const packageJson = require('~/package.json')
	const env = require('~/env')
	const currentEnv = packageJson.env || 'development'
	
	// 环境映射配置
	const urlEnvMap = {
		development: 'http://apph5.jinliwangluo.com',
		dev: 'http://apph5.jinliwangluo.com',
		test: 'https://apph5.yingbowl.com',
		production: 'https://apph5.pzds.com',
		prod: 'https://apph5.pzds.com',
		pre: 'https://apph5.pzpre.com'
	}

	// 判断登录状态
	const userToken = context.$store.state.user.token
	const userInfo = context.$store.state.user.userinfo
	const isLogin = !!(userToken && userInfo && userInfo.id)

	// 如果登录直接跳转凡科活动页
	if (isLogin) {
		const src = `${urlEnvMap[currentEnv]}/#/fkActivity?fkUrl=${fxUrl}&token=${userToken}&client=h5`
		window.open(src, '_blank')
	}
	// 没有登录就先跳转登录页
	else {
		context.$router.push(`/login?type=fkhd&fkUrl=${fxUrl}`)
	}
}
